export default {
  // Title
  waylineLibrary: 'Wayline Library',
  downloading: 'Downloading',

  // Tooltips
  waylinePlanning: 'Wayline Planning',
  refreshWaylineList: 'Refresh wayline list',
  importKmzWaylineFile: 'Import KMZ wayline file',
  aiAlgorithm: 'RC AI Algorithm',
  aiAlgorithmSwitch: 'RC AI Algorithm Switch',

  // Wayline types
  waypoint: 'Waypoint',
  planar: 'Planar',
  oblique: 'Oblique',

  // Menu items
  bindAlgorithm: 'Bind Algorithm',
  copyWayline: 'Copy Wayline',
  download: 'Download',
  edit: 'Edit',
  delete: 'Delete',

  // Labels
  updateTime: 'Update Time',

  // Delete confirmation dialog
  deleteWaylineConfirmTitle: 'After deleting the wayline, the content will be unrecoverable. Are you sure you want to delete this wayline?',
  deleteWaylineConfirmOk: 'OK',
  deleteWaylineConfirmCancel: 'Cancel',

  // Algorithm model dialog
  algorithmModelAdd: 'Algorithm Model Add',
  addModel: 'Add Model',
  skipFrameCount: 'Skip Frame Count',
  frame: 'frame',
  pushFrequency: 'Push Frequency',
  second: 'second',
  confidence: 'Confidence',
  modelName: 'Model Name:',
  startWaypoint: 'Start Algorithm Waypoint',
  endWaypoint: 'End Algorithm Waypoint',
  cancel: 'Cancel',
  confirm: 'Confirm',

  // Toast messages
  waylineFileNotFound: 'No copyable wayline file found',
  copyWaylineSuccess: 'Wayline copied successfully',
  deleteSuccess: 'Deleted successfully',
  aiToggleSuccess: '{action} successfully',
  aiOpen: 'Enabled',
  aiClose: 'Disabled',
  notFoundWayline: 'Wayline not found',
  fileUploadSuccess: '{fileName} file uploaded successfully',
  bindingAlgorithmSuccess: 'Algorithm bound successfully',

  // Other
  createWaylineInDJIWeb: 'Create wayline in DJI web (open in new window)',
  djiWebUrl: 'https://fh.dji.com/organization/fe22e2f5-3296-417c-bcfa-5cdc8b0503f6/project/561bd128-79c0-44b2-ae94-e56c8388b268#/wayline/create',

  // Wayline planning page waylinePlan.vue
  plan: {
    back: 'Back',
    saveWayline: 'Save wayline',
    waylineSettings: 'Wayline settings',
    restoreDefaultView: 'Restore default view',
    newWayline: 'New wayline',
    newWaylineName: 'New wayline',
    waylineName: 'Wayline name',
    enterWaylineName: 'Enter wayline name',
    deviceType: 'Device type',
    photoSettings: 'Photo settings',
    widePhoto: 'Wide-angle photo',
    zoomPhoto: 'Zoom photo',
    irPhoto: 'Infrared photo',
    verticalClimb: 'Vertical climb',
    obliqueClimbNotRecommended: 'Oblique climb (not recommended)',
    heightMode: 'Wayline height mode',
    altitudeHeight: 'Altitude (ASL)',
    relativeTakeoffHeight: 'Height relative to takeoff',
    relativeTerrainHeight: 'Height relative to terrain',
    globalWaylineSpeed: 'Global wayline speed',
    advancedSettings: 'Advanced settings',
    waypointType: 'Waypoint type',
    turnStraightStop: 'Straight flight, stop at waypoint',
    turnCoordinate: 'Coordinated turn, pass without stopping',
    turnCurveStop: 'Curved flight, stop at waypoint',
    turnCurvePass: 'Curved flight, pass without stopping',
    aircraftHeadingMode: 'Aircraft heading mode',
    headingFollowWayline: 'Follow wayline direction',
    headingFixed: 'Lock current heading',
    gimbalPitchControlMode: 'Gimbal pitch between waypoints',
    gimbalManual: 'Manual control',
    gimbalUsePointSetting: 'Use each waypoint setting',
    finishAction: 'Finish action',
    finishGoHome: 'Return to home automatically',
    finishNoAction: 'Exit wayline mode',
    finishAutoLand: 'Land in place',
    finishGotoFirstWaypoint: 'Return to start and hover',
    waypointList: 'Waypoint list',
    routeLength: 'Route\nlength',
    estimatedTime: 'Estimated\ntime',
    waypointCount: 'Waypoint',
    photos: 'Photos',
    waypointIndex: 'Waypoint {n}',
    deleteWaypoint: 'Delete waypoint',
    deleteAction: 'Delete action',
    addWaypoint: 'Add waypoint',
    leftClickAddTooltip: 'Left-click to add waypoints, right-click to finish drawing',
    longitude: 'Longitude',
    latitude: 'Latitude',
    height: 'Height',
    enterLongitude: 'Enter longitude',
    enterLatitude: 'Enter latitude',
    enterHeight: 'Enter height',
    zoom: 'Zoom',
    startRecord: 'Start recording',
    stopRecord: 'Stop recording',
    hover: 'Hover',
    takePhoto: 'Take photo',
    aircraftYaw: 'Aircraft yaw',
    gimbalPitch: 'Gimbal pitch',
    panoShot: 'Panorama',
    cameraZoom: 'Camera zoom',
    selectTakeoffFirst: 'Please select a takeoff point first',
    hoverMax900: 'Hover time cannot exceed 900s',
    hoverMin1: 'Hover time must be at least 1s',
    heightMax1500: 'Height cannot exceed 1500m',
    heightMin10: 'Height cannot be below 10m',
    maxSpeedReached: 'Maximum speed reached',
    minSpeedReached: 'Minimum speed reached',
    resetView: 'Reset view',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
  },
}